<form [formGroup]="filterParcelForm">
  <ts-page-header>
    <ng-container page-header-action-bar>
      <div class="flex justify-start items-center gap-2 w-full">
        <mat-form-field class="address-selector">
          <button
            type="button"
            class="font-black"
            mat-icon-button
            matPrefix
            (click)="getUserLocation()"
            *ngIf="showGetLocation"
          >
            <ts-icon icon="my_location"></ts-icon>
          </button>
          <input
            matInput
            google-place
            placeholder="Enter a location"
            [formControlName]="'address'"
            (onSelectParts)="setAddressParts($event)"
            (keydown.enter)="$event.preventDefault()"
            [autocomplete]="'off'"
          />
        </mat-form-field>
        <ts-button #filtersButton color="accent" type="stroked" icon="filter_alt" (click)="filtersOverlay.open()"
          >Filter
          <ng-container *ngIf="currentFilterAppliedFieldsCount$ | async as counter">
            <ts-badge
              [value]="counter === '0' ? 'None' : counter"
              [type]="counter === '0' ? 'transparent' : 'info'"
            ></ts-badge>
          </ng-container>
        </ts-button>
        <ts-button #markersButton color="accent" type="stroked" icon="ts_eye" (click)="markersOverlay.open()"
          >Markers
          <ng-container [ngSwitch]="displayMarker">
            <ts-badge *ngSwitchCase="'Project'" value="Deals" type="info"></ts-badge>
            <ts-badge *ngSwitchCase="'Property'" value="Properties" type="warning"></ts-badge>
            <ts-badge *ngSwitchDefault value="None" type="transparent"></ts-badge>
          </ng-container>
        </ts-button>
        <button class="ml-auto" mat-icon-button [matMenuTriggerFor]="moreMenu" *ngIf="displayMarker">
          <mat-icon [svgIcon]="'more_vert'"></mat-icon>
        </button>
      </div>
    </ng-container>
  </ts-page-header>
</form>

<app-overlay-helper #filtersOverlay [overlayOrigin]="filtersButton" [position]="position">
  <div class="map-filter" [formGroup]="filterForm">
    <div class="header">Filters</div>
    <div class="map-filter__text">
      <mat-form-field class="w-full">
        <mat-label>Owner</mat-label>
        <input [ts-empty-default]="null" matInput type="text" formControlName="owner" placeholder="" />
        <ng-container *ngTemplateOutlet="resetFormField; context: { formControlName: 'owner' }"></ng-container>
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>Owner Mailing Address</mat-label>
        <input matInput [ts-empty-default]="null" type="text" formControlName="owner_mailing_address" placeholder="" />
        <ng-container
          *ngTemplateOutlet="resetFormField; context: { formControlName: 'owner_mailing_address' }"
        ></ng-container>
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>Zoning</mat-label>
        <input matInput [ts-empty-default]="null" type="text" formControlName="zoning" placeholder="" />
        <ng-container *ngTemplateOutlet="resetFormField; context: { formControlName: 'zoning' }"></ng-container>
      </mat-form-field>
    </div>
    <div class="map-filter__min-max">
      <div class="map-filter__min-max__column">
        <mat-form-field>
          <mat-label>Building Size (SF)</mat-label>
          <input matInput type="number" formControlName="min_building_area_sq_ft" placeholder="Min" />
          <ng-container
            *ngTemplateOutlet="resetFormField; context: { formControlName: 'min_building_area_sq_ft' }"
          ></ng-container>
        </mat-form-field>
        <mat-form-field>
          <mat-label>&nbsp;</mat-label>
          <input matInput type="number" formControlName="max_building_area_sq_ft" placeholder="Max" />
          <ng-container
            *ngTemplateOutlet="resetFormField; context: { formControlName: 'max_building_area_sq_ft' }"
          ></ng-container>
        </mat-form-field>
      </div>
      <div class="map-filter__min-max__column">
        <mat-form-field>
          <mat-label>Lot Size (Acres)</mat-label>
          <input matInput type="number" formControlName="min_lot_area_acres" placeholder="Min" />
          <ng-container
            *ngTemplateOutlet="resetFormField; context: { formControlName: 'min_lot_area_acres' }"
          ></ng-container>
        </mat-form-field>
        <mat-form-field>
          <mat-label>&nbsp;</mat-label>
          <input matInput type="number" formControlName="max_lot_area_acres" placeholder="Max" />
          <ng-container
            *ngTemplateOutlet="resetFormField; context: { formControlName: 'max_lot_area_acres' }"
          ></ng-container>
        </mat-form-field>
      </div>
      <div class="map-filter__min-max__column">
        <mat-form-field>
          <mat-label>Lot Size (SF)</mat-label>
          <input matInput type="number" formControlName="min_lot_area_sq_ft" placeholder="Min" />
          <ng-container
            *ngTemplateOutlet="resetFormField; context: { formControlName: 'min_lot_area_sq_ft' }"
          ></ng-container>
        </mat-form-field>
        <mat-form-field>
          <mat-label>&nbsp;</mat-label>
          <input matInput type="number" formControlName="max_lot_area_sq_ft" placeholder="Max" />
          <ng-container
            *ngTemplateOutlet="resetFormField; context: { formControlName: 'max_lot_area_sq_ft' }"
          ></ng-container>
        </mat-form-field>
      </div>
      <div class="map-filter__min-max__column">
        <mat-form-field>
          <mat-label># Units</mat-label>
          <input matInput type="number" formControlName="min_units" placeholder="Min" />
          <ng-container *ngTemplateOutlet="resetFormField; context: { formControlName: 'min_units' }"></ng-container>
        </mat-form-field>
        <mat-form-field>
          <mat-label>&nbsp;</mat-label>
          <input matInput type="number" formControlName="max_units" placeholder="Max" />
          <ng-container *ngTemplateOutlet="resetFormField; context: { formControlName: 'max_units' }"></ng-container>
        </mat-form-field>
      </div>
      <div class="map-filter__min-max__column">
        <mat-form-field>
          <mat-label>Market Value</mat-label>
          <input matInput type="number" formControlName="min_estimated_value" placeholder="Min" />
          <ng-container
            *ngTemplateOutlet="resetFormField; context: { formControlName: 'min_estimated_value' }"
          ></ng-container>
        </mat-form-field>
        <mat-form-field>
          <mat-label>&nbsp;</mat-label>
          <input matInput type="number" formControlName="max_estimated_value" placeholder="Max" />
          <ng-container
            *ngTemplateOutlet="resetFormField; context: { formControlName: 'max_estimated_value' }"
          ></ng-container>
        </mat-form-field>
      </div>
    </div>
    <div class="flex flex-row justify-end items-center gap-4 mt-8">
      <ts-button *ngIf="(filterFormEmpty | async) === false" type="stroked" color="accent" (click)="clear()">
        <span>Clear</span>
      </ts-button>
      <ts-button
        [disabled]="(filterFormEmpty | async) || (filterFormSameAsActiveFilter | async)"
        type="flat"
        color="primary"
        (click)="run()"
      >
        <span>Run</span>
      </ts-button>
    </div>
  </div>
</app-overlay-helper>

<app-overlay-helper #markersOverlay [overlayOrigin]="markersButton" [position]="position">
  <div class="map-filter">
    <div class="header">Markers</div>
    <div class="w-fit mb-4">
      <mat-button-toggle-group
        [disabled]="isQuerying"
        #markersSelect
        [value]="displayMarker"
        (change)="onChangeDisplayMarker($event)"
      >
        <mat-button-toggle value="">No Markers</mat-button-toggle>
        <mat-button-toggle value="Project" [appAuthorize]="NewPermission.DEALS_VIEW" denyAction="disable">
          Deals
        </mat-button-toggle>
        <mat-button-toggle value="Property" [appAuthorize]="NewPermission.PROPERTIES_VIEW" denyAction="disable">
          Properties
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="markers-form" [ngClass]="{ loading: isQuerying }">
      <mat-form-field class="flex-auto w-full mt-4" *ngIf="displayMarker === 'Project'">
        <mat-label>Saved Views</mat-label>
        <mat-select class="text-disabled" [(ngModel)]="selectedView" (selectionChange)="onChangeSelectedView($event)">
          <mat-option [value]="null">--</mat-option>
          <mat-option *ngFor="let pipeline of pipelines" [value]="pipeline">
            {{ pipeline.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="flex flex-row items-center">
        @if (displayMarker) {
          <ts-filter
            size="medium"
            [fields]="typeFields | async"
            [filters]="filterValueList | async"
            [lookupContract]="lookupService"
            [hasGroups]="true"
            (addItem)="onAddFilterItem()"
            (filterDefChange)="onFilterDefChanged($event)"
            (filterRemove)="onFilterRemoved($event)"
            (filterClear)="onFilterCleared()"
            (filterApply)="onFilterApplied()"
          ></ts-filter>
        }
      </div>
    </div>
  </div>
</app-overlay-helper>

<mat-menu #moreMenu>
  <button appAuthorize="MAPS_EDIT_LAYOUT" mat-menu-item (click)="onEditLayout()" class="edit-layout-button">
    <mat-icon [svgIcon]="'edit'"></mat-icon>
    Edit Layout
  </button>
</mat-menu>

<ng-template #resetFormField let-formControlName="formControlName">
  <button
    class="map-filter__clear-button"
    matSuffix
    mat-icon-button
    (click)="filterForm.get(formControlName).patchValue(null)"
  >
    <ts-icon matPrefix icon="close"></ts-icon>
  </button>
</ng-template>
